import(/* webpackMode: "eager" */ "/var/www/eduegoo/frontend/app/subjects/page.tsx");
